/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "368")


  
    
export interface API56394Item {
  
  /** 父节点编号 */
  parentNodeNo?: string;
  
  /** 业务编号 */
  nodeNo?: string;
  
  /** 业务编号 */
  nodeName?: string;
  
  /** 原始编号 */
  bizNo?: string;
  
  /** 1-部门2-工作室3-ip */
  type?: number;
  
  /** OrgTeamIpTreeResult */
  nodes?: undefined[];
  
};
    
  



  export type API56394Req = {};



export interface API56394Res {
  /** T  */
  list?: API56394Item[];
  /**   */
  totalNumber?: any;
  /**   */
  totalPage?: any;
  /**   */
  rowId?: string;
  /**   */
  hasNext?: boolean;
  /**   */
  pageSize?: any;
  /**   */
  pageIndex?: any;
  
};


// 56394 部门工作室iP树

export interface IUseGetAPI56394Return {
  /** 部门工作室iP树: 接口请求状态 */
  isAPI56394Loading: boolean;
  /** 部门工作室iP树: 接口请求返回数据 */
  dataAPI56394: API56394Res;
  /**  部门工作室iP树: 接口数据请求方法 */
  fetchAPI56394Data:  ( config?: YWRequestConfig) => Promise<API56394Res>;
  /** 部门工作室iP树: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI56394 = ():IUseGetAPI56394Return => {
  let isMount = true;
  const [isAPI56394Loading, setIsAPI56394Loading] = useState(false);
  const [dataAPI56394, setDataAPI56394] = useState<API56394Res>({} as API56394Res);
  const requestUrl = `${basePath}/internal-control-biz/admin/ip/findOrgTeamIpTree`;

  const fetchAPI56394Data = async ( config?: YWRequestConfig): Promise<API56394Res> => {
  
    if ( isMount ) {
      setIsAPI56394Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API56394Res>(`${basePath}/internal-control-biz/admin/ip/findOrgTeamIpTree`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI56394(res || {} as API56394Res);
        setIsAPI56394Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI56394Loading(false);
      }
      return false as unknown as API56394Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI56394Loading,
    dataAPI56394,
    fetchAPI56394Data,
    requestUrl,
  }
}

